import { render, staticRenderFns } from "./viewLGFED.vue?vue&type=template&id=07cfc37e&scoped=true"
import script from "./viewLGFED.vue?vue&type=script&lang=js"
export * from "./viewLGFED.vue?vue&type=script&lang=js"
import style0 from "./viewLGFED.vue?vue&type=style&index=0&id=07cfc37e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfc37e",
  null
  
)

export default component.exports